import React from 'react';
import { Modal } from './Modal';

interface GiftModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const GiftModal: React.FC<GiftModalProps> = ({ isOpen, onClose }) => {
    const LIVERPOOL_URL = "https://mesaderegalos.liverpool.com.mx/milistaderegalos/51909119";

    const handleRedirect = () => {
        window.open(LIVERPOOL_URL, '_blank', 'noopener,noreferrer');
        onClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Mesa de regalos"
            size="md"
        >
            <div className="flex flex-col items-center text-center space-y-6">
                <p className="text-lg leading-relaxed">
                    Este regalo es para nuestra Luna de Miel 🍯<br/>Puedes contribuir a través de un sobre (con efectivo) el día de la boda, o con certificados de regalo de Liverpool dando click aquí<br/>👇
                </p>
                <button
                    onClick={handleRedirect}
                    className="w-[60%] h-14 bg-[#E10098] hover:bg-[#a4006e] transition-colors duration-300 rounded-lg p-6 flex justify-center items-center group"
                >
                    <img 
                        src="/images/liverpool-logo.svg" 
                        alt="Liverpool Logo" 
                        className="h-10 w-auto"
                    />
                </button>
            </div>
        </Modal>
    );
};

export default GiftModal;
